import { CCol, CInput, CRow, CSpinner } from "@coreui/react";
import cs from "classnames";
import React from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router";
import Button from "../../../components/Button/Button";
import DataCard from "../../../components/DataCard/DataCard";
import MatrixService from "../../../services/MatrixService";
import styles from "../Matrix.module.css";
import {toast} from "react-toastify";

const NumberInput = ({ modified, ...props }) => {
  return (
    <div className="position-relative">
      <CInput
        {...props}
        pattern="^[+-]?\d+(,\d{2})?"
        className={styles.numberInput}
      />
      <div className={styles.prc}>
        <span>%</span>
      </div>
    </div>
  );
};
const PartnerCorrectionPriceBox = () => {
  const { shop } = useParams();

  const { register, reset, handleSubmit } = useForm();

  const [update, { isLoading: isDataFetching }] = useMutation(
    MatrixService.updatePartnerCorretionPrice(),
    {
      onSuccess: () => {
        toast.success("Korekty wartości odkupu dla przedziałów cenowych zostały zaktualizowane");
      },
      onError: () => {
        toast.error("Wystąpił błąd");
      }
    }
  );

  const {
    isLoading: isDataLoading,
    data,
    refetch,
  } = useQuery(
    `correction-price-${shop}`,
    MatrixService.getPartnerCorrectionPrice({
      shop_symbol: shop,
    }),
    {
      onSuccess: (data) => {
        const parsedValues = data.reduce((a, b) => {
          return {
            ...a,
            ...{
              [b.id]: {
                min: b.min,
                max: b.max,
                correction: b.correction,
              },
            },
          };
        }, {});

        reset(parsedValues);
      },
    }
  );
  const onSubmit = async (values) => {
    const rows = Object.entries(values).map(([id, value]) => ({
      ...value,
      id,
    }));
    await update({ rows });
    await refetch();
  };

  const isLoading = !!isDataFetching || !!isDataLoading;

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="mt-4">
      <DataCard
        title={"Korekta wartości odkupu dla przedziałów cenowych"}
        HeaderButtons={
          <div>
            <Button type="submit">Zapisz</Button>
          </div>
        }
      >
        <CRow>
          <CCol sm="12" xl="12">
            {!!isLoading && (
              <div
                className={cs(
                  "d-flex justify-content-center align-items-center l-0 t-0 w-100 h-100 position-absolute",
                  styles.loaderContainer
                )}
              >
                <CSpinner
                  color="primary"
                  style={{ width: "4rem", height: "4rem" }}
                />
              </div>
            )}
            {!!data && (
              <table className="mt-4">
                <thead>
                  <tr>
                    <th className="p-2">Klasa</th>
                    <th className="p-2">Cena min</th>
                    <th className="p-2">Cena max</th>
                    <th className="p-2">Korekta wartości odkupu w %</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map(({ id, threshold, min, max, correction }) => (
                    <tr key={id}>
                      <td className="p-2 text-uppercase">{threshold}</td>
                      <td className="p-2">
                        <CInput name={`${id}.min`} innerRef={register} />
                      </td>
                      <td className="p-2">
                        <CInput
                          name={`${id}.max`}
                          innerRef={register}
                          type="number"
                        />
                      </td>
                      <td className="p-2">
                        <NumberInput
                          name={`${id}.correction`}
                          innerRef={register}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* <DataRow label="Nowe" value={<CInput />} /> */}
            {/* <DataRow label="Używane" value={<CInput />} /> */}
          </CCol>
        </CRow>
      </DataCard>
    </form>
  );
};

export default PartnerCorrectionPriceBox;
